<template>
  <div class="data-push-container">
    <!-- 数据推送配置列表 -->
    <canvas-glass-card title="ERP数据推送配置" variant="light" :hoverable="false" class="table-card">
      <template #header>
        <a-row>
          <a-col flex="auto">
            <span class="glass-card__title">ERP数据推送配置</span>
          </a-col>
          <a-col flex="180px">
            <a-row justify="space-between" :wrap="false">
              <a-button type="primary" @click="pushAll">
                <template #icon>
                  <icon-upload />
                </template>
                推送所有数据
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </template>

      <!-- 数据推送配置表格 -->
      <a-table
        row-key="id"
        :columns="tableColumns"
        :data="pushConfigList"
        :pagination="false"
        :loading="loading"
        column-resizable
        stripe
        :bordered="{cell:true}"
      >
        <template #action="{ record }">
          <a-space>
            <a-button type="text" size="mini" status="success" @click="pushSingle(record.id)" 
                      class="button-table-option">
              <template #icon>
                <icon-upload />
              </template>
              推送
            </a-button>
          </a-space>
        </template>
      </a-table>
    </canvas-glass-card>

    <!-- 推送结果展示 -->
    <canvas-glass-card v-if="pushResult" title="推送结果" variant="light" :hoverable="false" class="result-card">
      <a-alert type="info">
        <template #title>推送结果</template>
        <div style="white-space: pre-wrap;">{{ pushResult }}</div>
      </a-alert>
    </canvas-glass-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { Message } from '@arco-design/web-vue'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import { 
  IconUpload
} from '@arco-design/web-vue/es/icon'
import { pushWorkOrders } from '@/apis/system/data-sync'

// 推送配置列表
const pushConfigList = ref([])
// 加载状态
const loading = ref(false)
// 推送结果
const pushResult = ref('')

// 表格列定义
const tableColumns = ref([
  { title: '推送项', dataIndex: 'name', width: 200, ellipsis: true, tooltip: true },
  { title: '表名', dataIndex: 'tableName', width: 200, ellipsis: true, tooltip: true },
  { title: '操作', dataIndex: 'action', width: 120, slotName: 'action', align: 'center', fixed: 'right' }
])

// 获取推送配置列表
const fetchPushConfigList = async () => {
  try {
    loading.value = true
    // TODO: 实现获取推送配置列表的API调用
    // 这里暂时使用模拟数据
    pushConfigList.value = [
      { id: 1, name: '工单数据推送', tableName: 't_workorder_info' },
    ]
  } catch (error) {
    Message.error('获取推送配置列表失败: ' + error.message)
    console.error('获取推送配置列表失败:', error)
  } finally {
    loading.value = false
  }
}

// 推送单个数据
const pushSingle = async (id) => {
  try {
    const response = await pushWorkOrders(id)
    Message.success(`数据推送成功`)
    pushResult.value = `数据推送成功: ${response}`
  } catch (error) {
    Message.error('推送失败: ' + error.message)
    pushResult.value = `推送失败: ${error.message}`
    console.error('推送失败:', error)
  }
}

// 推送所有数据
const pushAll = async () => {
  try {
    const response = await pushWorkOrders()
    Message.success('所有数据推送完成')
    pushResult.value = `所有数据推送完成: ${response}`
  } catch (error) {
    Message.error('推送失败: ' + error.message)
    pushResult.value = `推送失败: ${error.message}`
    console.error('推送失败:', error)
  }
}

// 组件挂载时获取数据
onMounted(() => {
  fetchPushConfigList()
})
</script>

<style scoped>
.data-push-container {
  padding: 20px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.button-table-option {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
}

.result-card {
  margin-top: 20px;
}
</style>